import { LOCATION_CHANGE } from '@/constants/ActionTypes.js';

export const locationChange = newLocation => ({
  type: LOCATION_CHANGE,
  payload: newLocation,
});
